<template>
  <div class="container">
    <div style="position: relative">
      <img  src="../../assets/header_bg.png" style="width: 100%;;max-height: 816px"/>
      <div style="width: 1245px;text-align: center;position: absolute;left: 50%;transform: translateX(-50%);top: 10vw;">
        <p style="font-size: 56px;font-weight: 500;color: #fff;">数字创造价值，科技引领未来</p>
        <p style="font-size: 26px;color: #fff;font-weight: lighter;margin-top: 20px;">Digital creates value, technology leads the future</p>
      </div>
      <div id="play_video" style="position: absolute;width: 26.6vw;height: 13.4vw;top: 22vw;left: 50%;transform: translateX(-50%);cursor: pointer">
<!--        <img src="../../assets/video-img.png" width="100%">-->
        <video width="100%" height="100%" controls>
          <source src="../../assets/1.mp4" type="video/mp4">
          您的浏览器不支持 HTML5 video 标签。
        </video>
      </div>
    </div>
<!--    <div class="swiper-container">-->
<!--      <div class="swiper-wrapper">-->
<!--           <div class="swiper-slide"  v-for="items in barlist" :key = "items.id" style="width: 100%;height: 600px">-->
<!--             <a :href="items.fcarouselHref" target="_blank">-->
<!--               <img  :src="baseUrl+items.fcarouselUrl" style="width: 100%;;height: 600px"/>-->
<!--             </a>-->
<!--           </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; 如果需要分页器 &ndash;&gt;-->
<!--      <div class="swiper-pagination"></div>-->

<!--      &lt;!&ndash; 如果需要导航按钮 &ndash;&gt;-->
<!--      <a href="javascript:;" class="prev"></a>-->
<!--      <a href="javascript:;" class="next"></a>-->

<!--    </div>-->
    <div class="i1">
      <div class="box">
        <div class="title">
          <h2>解决方案</h2>
          <h3>SOLUTION</h3>
        </div>

        <div id="div_Solution" class="i1_main clearfix">
          <div v-for="(item,index) in solutions">
            <div class="pic_box pic_box_big i1_list" v-if="index === 0 || index === 6">
              <img :src="baseUrl + item.fsolutionUrl" alt="IT综合运维管理方案">
              <div class="content_text">
                <p class="content_title">{{item.fsolutionName}}</p>
                <p class="content_main">{{item.fsolutionSummary}}</p>
              </div>
            </div>
            <router-link :to="{path: '/solutionDetail',query:{id:item.fsolutionId}}"  v-bind:class="{margin_0:index%3===0}" :key='index' class="i1_list" v-else>
              <div class="pic_box">
                <img :src="baseUrl + item.fsolutionUrl" alt="IT综合运维管理方案">
                <div class="content_text">
                  <p class="content_title">{{item.fsolutionName}}</p>
                  <p class="content_main">{{item.fsolutionSummary}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="i3">
      <div class="box clearfix">
        <div class="pic_box">
          <img src="../../assets/8.png" alt="">
        </div>
        <div id="div_ky" class="text">
          <div class="tt">
            <h2>{{companyInfo.fprofileName}}</h2>
          </div>
          <div class="wrap">
            <p><span style="font-family:Microsoft YaHei;font-size:14px;">
            <span style="color:#FFFFFF;display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 5;overflow: hidden;">{{companyInfo.fprofileSummary}}</span>
<!--            <span style="color:#FFFFFF;">......</span>-->
            </span>
            </p>
            <p><span style="color:#FFFFFF;">&nbsp;</span></p>
            <p>&nbsp;</p>
            <p>
            <span style="font-family:Microsoft YaHei;font-size:12px;" v-html="companyInfo.fprofile">
            </span>
            </p>
            <p>
          <span style="color:#FFFFFF;font-family:Microsoft YaHei;font-size:12px;">
            <span style="color:#FFFFFF;font-size:14px;">

            </span>
          </span>&nbsp;
            </p>
          </div>
          <router-link to="/about" class="delil fr">了解详情 &gt;<span>LEARN MORE</span></router-link></div>
      </div>
    </div>
    <div class="i4">
      <div class="box">
        <div id="cooperative_customer" class="title">
          <h2>合作客户</h2>
          <h3>COOPERATION</h3>
        </div>
        <div id="div_customer" class="i4_main" v-if="Cooperation">
          <div class="top about_top clearfix">
            <a href="javascript:;" v-bind:class="{right:index%4===0}"  v-for="(item,index) in Cooperation"  :key="index">
              <img :src="baseUrl + item.fcooperation" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="i5">
      <div class="box">
        <div class="title">
          <h2>公司动态</h2>
          <h3>NEWS</h3>
        </div>
        <div id="div_news" class="i5_main clearfix" >
          <router-link  :to="{path: '/trendDetail',query:{id:item.fnewsId}}" class="i5_list" v-for="(item,index) in TrendsDate" :key="index">
            <img v-if="item.fimgUrl" :src="baseUrl + item.fimgUrl" alt="">
            <div class="text clearfix">
              <h2 v-if="item.ftitle">{{item.ftitle}}</h2>
              <div v-if="item.fabstract">{{item.fabstract}}</div>
              <span class="fr" v-if='item.freleaseDate'>{{item.freleaseDate}}</span>
            </div>
          </router-link>
        </div>
        <router-link to="/trends" class="more">查看更多</router-link>
      </div>
    </div>
    <div class="video_fixed">
      <div class="video">
        <video src="../../assets/1.mp4" controls=""></video>
        <a href="javascript:;" class="close"><img src="../../assets/close.png"></a>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
  import Swiper from "swiper"
  import 'swiper/dist/css/swiper.css';
  import $ from 'jquery'
  export default {
    name: "index-content",
    data(){
      return{
        barlist:[],//轮播图片
        solutions:[],
        Cooperation:[],
        TrendsDate:[],
        companyInfo:'',
        baseUrl:'',
      }
    },
    mounted(){
      this.baseUrl = process.env.API_ROOT;
      this.getBar()
      this.getSolutionDate()
      this.getCompanyCooperation()
      this.getTrendsDate()
      this.getCompanyDate()
      // $("#play_video").click(function(){
      //   $(".video_fixed").stop(true,true).fadeIn(600,'swing');
      // })
      //
      // $(".video_fixed .close").click(function(event) {
      //   /* Act on the event */
      //   $(this).parents(".video_fixed").stop(true,true).hide(600);
      //   $(".video_fixed").find("video")[0].load();
      // });
    },
    methods:{
      getBar(){
        axios.get('/api/carousel?page=1&limit=10').then((res) => {
          if(res.data.success){
            this.barlist = res.data.items
            this.$nextTick(function () {
              new Swiper('.swiper-container', {
                loop: true,
                navigation: {
                  nextEl: '.next',
                  prevEl: '.prev',
                },
                pagination: {
                  el: '.swiper-pagination',
                },
                speed: 300,
                autoplay: {
                  delay: 4000
                },

              })
            })
          }else{
            this.$message.error(res.data.msg)
          }
        })

      },
      getCompanyDate(){
        axios.get('/api/profile').then((res) => {
          if(res.data.success){
            this.companyInfo = res.data.items?res.data.items[0]:''
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getSolutionDate(){
        axios.get('/api/solution').then((res) => {
          if(res.data.success){
            this.solutions = res.data.items
            this.$nextTick(()=>{
              $(".i1_list").hover(function(){
                $(this).find('.icon').stop(true,true).animate({bottom:"100px"},300,'swing')
                $(this).find('.text').stop(true,true).delay(500).animate({bottom:"40px"},450,'swing')
              },function(){
                $(this).find('.icon').stop(true,true).delay().animate({bottom:"10px"},450,'swing')
                $(this).find('.text').stop(true,true).animate({bottom:"-60px"},300,'swing')
              })
            })
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getCompanyCooperation(){
        axios.get('/api/cooperation').then((res) => {
          if(res.data.success){
            this.Cooperation = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getTrendsDate(){
        axios.get(`/api/companyNews`).then((res) => {
          if(res.data.success){
            this.TrendsDate = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
    }
  }
</script>

<style scoped>
  .right{
    margin-right: 0;
    background: none
  }
  .margin-0{
    margin-right: 0px
  }
  .prev, .next{
    width: 38px;
    height: 38px;
    position: absolute;
    top: 50%;
    outline: none;
    margin-top: -14px;
    z-index: 600;
  }
  .prev{
    left: 10px;
    outline: none;
    background: url(../../assets/25.png) no-repeat center center;
  }
  .next{
    right: 10px;
    background: url(../../assets/26.png) no-repeat center center;
  }
  .title{
    text-align: center;
    background: url(../../assets/2.png) no-repeat center 15px;
  }
  .title h2{
    font-size: 30px;
    color: #333333;
  }
  .title h3{
    font-size: 14px;
    color: #666666;
    margin-top: 10px;
  }
  .i1{
    width: 100%;
    padding-top: 60px;
    padding-bottom: 40px;
  }
  .i1 .i1_main{
    width: 100%;
    /*display: flex;*/
    /*justify-content: space-between;*/
    margin-top: 60px;
  }
  .i1 .i1_main .i1_list{
    display: block;
    width: 390px;
    height: 316px;
    float: left;
    background-color: #fff;
    margin-left: 12px;
    margin-right: 12px;
    position: relative;
    margin-bottom: 21px;
    overflow: hidden;
  }
  .i1 .i1_main .i1_list .pic_box{
    width: 390px;
    height: 316px;
  }
  .i1 .i1_main .i1_list .pic_box .content_text{
    padding: 20px;
  }
  .i1 .i1_main .i1_list .pic_box .content_text .content_title{
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
  }
  .i1 .i1_main .i1_list .pic_box .content_text .content_title:hover{
    color: #1782E7;
  }
  .i1 .i1_main .i1_list .pic_box .content_text .content_main{
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .i1 .i1_main .i1_list .pic_box .content_text .content_main:hover {
    color: #999999;
  }
  .i1 .i1_main .i1_list .pic_box img{
    width: 390px;
    height: 180px;
  }
  .i1 .i1_main .pic_box_big img{
    width: 390px;
    height: 316px;
  }
  .i1 .i1_main .pic_box_big .content_text{
    position: relative;
    z-index: 999;
    top: -50%;
    left: 50%;
    transform: translate(-50% , -50%);
    /*padding: 20px;*/
  }
  .i1 .i1_main .pic_box_big .content_text .content_title{
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 72px;
    text-align: center;
  }
  .i1 .i1_main .pic_box_big .content_text .content_title:hover{
    color: #FFFFFF;
  }
  .i1 .i1_main .pic_box_big .content_text .content_main{
    margin-top: 8px;
    font-size: 18px;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
    padding: 0 60px;
  }
  .i1 .i1_main .pic_box_big .content_text .content_main:hover {
    color: #fff;
  }
  .i1 .i1_main .i1_list .zz{
    position: absolute;
    top: 0;
    left: 0;
    width: 375px;
    height: 240px;
    transition: all .8s;
    -moz-transition: all .8s; /* Firefox 4 */
    -webkit-transition: all .8s; /* Safari 和 Chrome */
    -o-transition: all .8s; /* Opera */
  }
  .i1 .i1_main .i1_list .zz .icon{
    text-align: center;
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
  }
  .i1 .i1_main .i1_list .zz .icon h2{
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    line-height: 35px;

  }
  .i1 .i1_main .i1_list .zz .text{
    width: 300px;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    bottom: -60px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    line-height: 30px;
  }
  .i1 .i1_main .i1_list:hover .zz{
    background: rgba(126,174,30,.8);
  }
  .i3{
    width: 1920px;
    height: 610px;
    background: url(../../assets/25.jpg) no-repeat center center;
    position: relative;
    left: 50%;
    margin-left: -960px;
    margin-top: 130px;
  }
  .i3 .box{
    position: relative;
  }
  .i3 .box .pic_box{
    position: absolute;
    left: 0;
    top: -80px;
    width: 500px;
    height: 580px;
    z-index: 100;
    cursor: pointer;
  }
  .i3 .box .text{
    width: 525px;
    border:7px solid #3b3f61;
    padding: 35px 70px 40px 320px;
    position: absolute;
    right: 0;
    top: 50px;
  }

  .i3 .box .delil{
    text-decoration: none;
    width: 160px;
    color: #333;
    margin-top: 20px;
    font-size: 16px;
    margin-right: 20px;
    position: relative;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    display: block;
    z-index: 10;

  }
  .i3 .box .delil span{
    font-size: 24px;
    color: #eee;
    font-weight: bold;
    position: absolute;
    left: 50px;
    width: 170px;
    top: -10px;
    z-index: -1;
  }
  .i3 .box .delil:hover{
    border-color: #363958
  }
  .i3 .box .text .tt{
    padding-top: 40px;
    background: url(../../assets/26.jpg) no-repeat left top;
  }
  .i3 .box .text .tt h2{
    font-size: 30px;
    color: #ffffff;
    /*background: url(../../assets/11.png) left bottom no-repeat;*/
    /*padding-top: 40px;*/
  }
  .i3 .box .text .wrap{
    width: 100%;
    font-size: 14px;
    color: #efefef;
    line-height: 30px;
    margin-top: 25px;
    padding-bottom: 40px;
  }
  .i3 .box .text .wrap span{
    color: #333;
  }

  .i4{
    width: 100%;
    padding-top: 100px;
    padding-bottom: 80px;
    background: #fff;
  }
  .i4 .i4_main{
    width: 100%;
    margin-top: 60px;
  }
  .i4 .i4_main .top{
    width: 100%;
    padding-bottom: 75px;
    border-bottom: 1px solid #ccc;
  }
  .i4 .i4_main .top a{
    display: block;
    width: 270px;
    height: 90px;
    overflow: hidden;
    margin-right: 26.6px;
    float: left;
  }
  .i4 .i4_main .top a img{
    display: block;
    width: 270px;
    height: 90px;
  }

  .i5{
    width: 100%;
    padding-top: 60px;
    padding-bottom: 80px;
    background: #eee;
  }
  .i5 .i5_main{
    width: 100%;
    margin-top: 60px;
  }
  .i5 .i5_main .i5_list{
    display: block;
    width: 590px;
    height: 331px;
    position: relative;
    float: left;
    margin-right: 20px;
  }
  .i5 .i5_main .i5_list:before{
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url(../../assets/hover.png) no-repeat center center;
  }
  .i5 .i5_main .i5_list:nth-child(2){
    margin-right: 0;
  }
  .i5 .i5_main .i5_list:after{
    content: "";
    display: block;
    width: 590px;
    height: 10px;
    background: #8ec31f;
    position: absolute;
    bottom: -10px;
    transform:scale(0,1);
    -ms-transform:scale(0,1); 	/* IE 9 */
    -moz-transform:scale(0,1); 	/* Firefox */
    -webkit-transform:scale(0,1); /* Safari 和 Chrome */
    -o-transform:scale(0,1); 	/* Opera */
    transition: all .8s;
    -moz-transition: all .8s; /* Firefox 4 */
    -webkit-transition: all .8s; /* Safari 和 Chrome */
    -o-transition: all .8s; /* Opera */
  }
  .i5 .i5_main .i5_list .text{
    width: 100%;
    position: absolute;
    bottom: 20px;
    width: 500px;
    left: 50%;
    margin-left: -250px;
    transition: all .8s;
    -moz-transition: all .8s; /* Firefox 4 */
    -webkit-transition: all .8s; /* Safari 和 Chrome */
    -o-transition: all .8s; /* Opera */
  }
  .i5 .i5_main .i5_list .text h2{
    font-size: 18px;
    color: #fff;
    margin-bottom: 15px;
  }
  .i5 .i5_main .i5_list .text div{
    font-size: 14px;
    color: #fff;
    line-height: 30px;
    padding-right: 60px;
  }
  .i5 .i5_main .i5_list .text span{
    display: block;
    font-size: 14px;
    color: #fff;
    padding-left: 20px;
    background: url(../../assets/12.png) no-repeat left center;
  }
  .i5 .i5_main .i5_list:hover:after{
    transform:scale(1,1);
    -ms-transform:scale(1,1); 	/* IE 9 */
    -moz-transform:scale(1,1); 	/* Firefox */
    -webkit-transform:scale(1,1); /* Safari 和 Chrome */
    -o-transform:scale(1,1); 	/* Opera */
  }
  .i5 .i5_main .i5_list:hover .text{
    bottom:40px;
  }

  .i5 .more{
    display: block;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    color: #fff;
    text-decoration: none;
    background: url(../../assets/13.png) no-repeat 120px center #20244f;
    margin: 60px auto 0;
  }
  .i5 .more:hover{
    background: url(../../assets/13.png) no-repeat 120px center #36395a;
  }
  .video_fixed{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(0,0,0,.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2500;
    display: none;
  }
  .video_fixed .video{
    width: 1000px;
    height: 500px;
    position: absolute;
    left: 50%;
    margin-left: -500px;
    top: 50%;
    margin-top: -250px;
  }
  .video_fixed .video video{
    width: 100%;
  }
  .video_fixed .video .close{
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  #div_news>a>img {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexContent/indexContent.vue